import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsHelpbuttonDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getAssistanceDetail(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_getAssistanceDetails', item, options);
  }

  public filterAssistanceList(context, lang, udid, centerInternalIdList, datetimeFrom, datetimeTo, evaluationList, statusList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalIdList, datetimeFrom, datetimeTo, evaluationList, statusList };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_filterAssistanceList', item, options);
  }
}
